
    import Vue from "vue";
    //components
    import RomaBreadcrumbs from "@/components/commons/RomaBreadcrumbs.vue";
    import RomaUnit from "@/components/units/RomaUnit.vue";
    import RomaAdvance from "@/components/advance/RomaAdvance.vue";
    import RomaPercentage from "@/components/commons/RomaPercentage.vue";
    //store
    import UnitPlan from "@/store/units/UnitPlan";

    export default Vue.extend({
        name: "OrganizerUnit",
        data() {
            return {
                unit: null,
            };
        },
        computed: {
            dataReady() {
                const unit = UnitPlan.find(this.$route.params.id);
                if ((unit === null || unit === undefined || unit.id <= 0) && this.$route.name === "organizer-advance") {
                    window.location.href = "/organizer";
                    alert("El plan unidad debe estar en la lista de planes unidad");
                    return null;
                }
                if (unit instanceof UnitPlan && !(this.unit instanceof UnitPlan)) this.setUnit(unit);
                return this.unit;
            },
        },
        methods: {
            setUnit(unit) {
                this.unit = unit;
            }
        },
        components: {
            RomaBreadcrumbs,
            RomaUnit,
            RomaAdvance,
            RomaPercentage
        }
    });
